<template>
  <div>
    <datetime
      :type='datetime.type'
      :format='datetime.format'
      input-class='rp-input is-small'
      v-bind:class="{ 'is-danger': status }"
      v-bind:value="value"
      v-on:input="updateValue"
      :phrases="{ok: t.ok, cancel: t.cancel}"
      class="theme-color">
    </datetime>

    <div class="validation-text" v-if="status === true">
      {{ t.pleaseInsertText }}
    </div>
    <div v-html="style"></div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'DatetimeInput',
  props: {
    value: String,
    inputData: {
      type: Object,
      default: () => {
        return {
          id: 1,
          type: 'datetime',
          required: '0',
          placeholder: '',
          option: []
        }
      }
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          pleaseInsertText: 'Please insert data',
          ok: 'Ok',
          cancel: 'Cancel'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          pleaseInsertText: 'กรุณากรอกข้อมูล',
          ok: 'ตกลง',
          cancel: 'ยกเลิก'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          pleaseInsertText: 'Vui lòng nhập dữ liệu',
          ok: 'Đồng ý',
          cancel: 'Hủy'
        }
      }
    },
    color () {
      return Cart.getColor()
    }
  },
  data () {
    return {
      status: false,
      datetime: {
        type: '',
        format: ''
      },
      style: ''
    }
  },
  methods: {
    validateInput () {
      let result = true

      if (this.value === '' && this.inputData.required === '1') {
        this.status = true
        result = false

        return result
      } else {
        this.status = false
      }
      return result
    },
    updateValue (value) {
      this.$emit('input', value)
      this.status = false
    }
  },
  created () {
    if (this.inputData.type === 'datetime') {
      this.datetime.type = 'datetime'
      this.datetime.format = 'yyyy-MM-dd HH:mm'
    } else {
      this.datetime.type = 'date'
      this.datetime.format = 'yyyy-MM-dd'
    }
    this.style = '<style>.theme-color .vdatetime-popup__header,'
    this.style += '.theme-color .vdatetime-calendar__month__day--selected > span > span,'
    this.style += '.theme-color .vdatetime-calendar__month__day--selected:hover > span > span'
    this.style += '{ background:' + this.color.primaryMain + ';'
    this.style += 'color:' + this.color.primarySub + ' }'
    this.style += '.theme-color .vdatetime-year-picker__item--selected,'
    this.style += '.theme-color .vdatetime-time-picker__item--selected,'
    this.style += '.theme-color .vdatetime-popup__actions__button'
    this.style += '{ background:' + this.color.primaryMain + ';'
    this.style += 'color:' + this.color.primarySub + ' }'
  }
}
</script>

<style lang="scss" scoped>
.validation-text {
  color: red;
  font-size: 0.75em;
}
</style>

<style lang="scss">
.vdatetime.is-danger {
  input.vdatetime-input {
    border-color: #ff3860;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/share/form/DatetimeInput.vue